import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import StartScreen from './components/StartScreen';
import QuizScreen from './components/QuizScreen';
import ResultScreen from './components/ResultScreen';
import { QuizProvider } from './context/QuizContext';
import './App.css';

function App() {
  return (
    <QuizProvider>
      <Router>
        {/* Neuer Hintergrund mit brand-gray */}
        <div className="min-h-screen bg-brand-gray">
          <Routes>
            <Route path="/" element={<StartScreen />} />
            <Route path="/quiz" element={<QuizScreen />} />
            <Route path="/result" element={<ResultScreen />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </QuizProvider>
  );
}

export default App;